export default __webpack_public_path__ + "static/media/17_moose.55150bdd.JPG";